import { Injectable } from '@angular/core';
import { Headers, Http } from "@angular/http";
import { Customer } from "../../models/customer";
import { JsonApiDatastore, JsonApiDatastoreConfig, JsonApiModel, ModelType } from 'angular2-jsonapi';
import { UserStorageService } from "../authentication/user-storage.service";
import { Address } from "../../models/address";
import { OpeningHour } from "../../models/opening-hour";
import { Site } from "../../models/site";
import { Appointment } from "../../models/appointment";
import { Report } from "../../models/report";
import { Config } from "../../../../environments/environment";
import { ReportCategory } from "../../models/report-category";
import { CustomerCategory } from "../../models/customer-category";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { AuthenticationService } from "../authentication/authentication.service";
import { JsonApiQueryData } from "angular2-jsonapi/dist/models/json-api-query-data";
import { Observable } from "rxjs/Observable";
import { OAuthToken } from "../../models/oauthtoken";

@Injectable()
@JsonApiDatastoreConfig({
  baseUrl: Config.baseUrl + "/api",
  models: {
    customer: Customer,
    address: Address,
    opening_hour: OpeningHour,
    site: Site,
    appointment: Appointment,
    report: Report,
    report_category: ReportCategory,
    customer_category: CustomerCategory
  }
})
export class DataStoreService extends JsonApiDatastore {

  constructor(http: Http, private userStorage: UserStorageService, private authenticationService: AuthenticationService) {
    super(http);
    this.subscribeAccessToken();
  }

  private addAuthenticationHeader(token?: OAuthToken) {
    if (token != null) {
      let headers = new Headers({
        "Authorization": "Bearer " + token.access_token,
      });
      this.headers = headers;
    }
  }


  findAll<T extends JsonApiModel>(modelType: ModelType<T>, params?: any, headers?: Headers, customUrl?: string): Observable<JsonApiQueryData<T>> {
    return super.findAll(modelType, params, headers, customUrl)
      .catch(error => {
        if (error == "401 - Unauthorized") {
          return this.authenticationService.refreshAccessToken(this.userStorage.oauthToken.refresh_token)
            .do(token => this.addAuthenticationHeader(token))
            .flatMap(response => super.findAll(modelType, params, headers, customUrl)) as ErrorObservable;
        }
      })
  }

  private subscribeAccessToken() {
    this.userStorage.token$.subscribe(token => this.addAuthenticationHeader(token));
  }
}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/api/data-store.service.ts